export enum UsuarioStatus {
  AguardandoAprovacao = 1,
  AguardandoTrocaDeSenha = 2,
  Autorizado = 3,
  Bloqueado = 4,
}

export const UsuarioStatusNomeMap = new Map<UsuarioStatus, string>([
  [UsuarioStatus.AguardandoAprovacao, 'Aguardando Aprovação'],
  [UsuarioStatus.AguardandoTrocaDeSenha, 'Aguardando Troca de Senha'],
  [UsuarioStatus.Autorizado, 'Autorizado'],
  [UsuarioStatus.Bloqueado, 'Bloqueado'],
]);
